import { render, staticRenderFns } from "./HeadlineStatistic.vue?vue&type=template&id=2b8a73ca&scoped=true&"
import script from "./HeadlineStatistic.vue?vue&type=script&lang=js&"
export * from "./HeadlineStatistic.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineStatistic.vue?vue&type=style&index=0&id=2b8a73ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8a73ca",
  null
  
)

export default component.exports